import React, { useState, useContext } from "react";
import withRouter from "./WithRouter"; // Custom Router until rewritten with hooks.
//styles
import "./App.css";
import "./Bootstrap.css";
import NavigationBar from "./NavigationBar";
import Footer from "./footer";
//Admin
import AdminLogin from "./admin/AdminLogin";
import ClassTypes from "./admin/ClassTypes";
import VenueList from "./admin/VenueList";
import Venue from "./admin/Venue";
import RegularClassManage from "./admin/RegularClassManage";
import BlockClassManage from "./admin/BlockClassManage";
import TutorList from "./admin/TutorList";
import CustomerList from "./admin/CustomerList";
import CustomerView from "./admin/CustomerView";
import RegisterManage from "./admin/RegisterManage";
import BlockRegister from "./admin/BlockRegister";
import AwardsTypesList from "./admin/AwardsTypes";
import AwardParticipant from "./admin/AwardParticipant";
import ReportCardGenerate from "./admin/ReportCardGenerate";
import ReportCardView from "./admin/ReportCardView";
import OverviewPage from "./admin/OverviewPage";
import Configure from "./admin/Configure";
import ForgotPasswordAdmin from "./admin/ForgotPassword";
import ReplacePasswordAdmin from "./admin/ReplacePassword";
//Customer
import CustomerLogin from "./customer/CustomerLogin";
import CustomerSignup from "./customer/CustomerSignup";
import Dashboard from "./customer/Dashboard";
import CustomerOverview from "./customer/CustomerOverview";
import Checkout from "./customer/Checkout";
import BlockCheckout from "./customer/BlockCheckout";
import SignupClassView from "./customer/SignupClassView";
import SignupBlockView from "./customer/SignupBlockView";
import WasWaiting from "./customer/WasWaiting";
import ForgotPassword from "./customer/ForgotPassword";
import ReplacePassword from "./customer/ReplacePassword";
import ParticipantAwards from "./customer/ParticipantAwards";
import ParticipantProgress from "./customer/ParticipantProgress";
import ParticipantProgressView from "./customer/ParticipantProgressView";
import InfoOnlyClassView from "./customer/InfoOnlyClassView";
import InfoOnlyBlockView from "./customer/InfoOnlyBlockView";
import Success from "./customer/Success";
import Failure from "./customer/Failure";
//Tutor
import TutorOverview from "./tutor/TutorOverview";
import TutorClassInfoParent from "./tutor/TutorClassInfoParent";
import TutorBlockInfoParent from "./tutor/TutorBlockInfoParent";
import TutorRegisterManage from "./tutor/TutorRegisterManage";
import TutorBlockRegister from "./tutor/TutorBlockRegister";
import TutorLogin from "./tutor/TutorLogin";
import ForgotPasswordTutor from "./tutor/ForgotPassword";
import ReplacePasswordTutor from "./tutor/ReplacePassword";
import TutorAwardParticipant from "./tutor/TutorAwardParticipant";
import TutorReportCardView from "./tutor/TutorReportCardView";
import TutorReportCardGenerate from "./tutor/TutorReportCardGenerate";
//Not Found and Other General Components
import ScrollToTop from "./common/ScrollToTop";
import NotFound from "./common/NotFound";
import AnalyticsProvider from "./common/AnalyticsProvider";
//Router
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// Import global business context
import { BusinessContextConsumer } from "./BusinessContext.js";
import LoadingSpinner from "./LoadingSpinner";


const App = () => {
  const [updatedLoginKey, setUpdatedLoginKey] = useState(0);
  const context = useContext(BusinessContextConsumer);
  const { finishedBusinessLoad, businessID } = context;
  //The updated Login Key state will be passed from props in the login forms, causing rerender of the login component if it is changed.
  //This function will be called from the login forms on successful login.
  const updateLoginKey = () => {
    const newKey = updatedLoginKey + 1;
    setUpdatedLoginKey(newKey);
  };

  if (finishedBusinessLoad && businessID) {
    return (
      <div className='App'>
        <AnalyticsProvider>
          <Router basename='/'>
            <ScrollToTop />
            <NavigationBar key={updatedLoginKey} />
            <Routes>
              {/* Public Routes */}
              <Route
                exact
                path='/login'
                element={<CustomerLogin updateLoginKey={updateLoginKey} />}
              />
              <Route
                exact
                path='/signup'
                element={<CustomerSignup updateLoginKey={updateLoginKey} />}
              />
              <Route exact path='/reset' element={<ForgotPassword />} />
              <Route exact path='/reset/:token/:id' element={<ReplacePassword />} />
              <Route exact path='/' element={<CustomerOverview/>} />

              {/* Customer Routes */}
              <Route exact path='/dashboard/' element={<Dashboard />} />
              <Route exact path='/waswaiting/:classid/:participantid' element={<WasWaiting />} />
              <Route exact path='/checkout/:classid/' element={<Checkout />} />
              <Route exact path='/checkout-block/:blockid/' element={<BlockCheckout />} />
              <Route exact path='/signup/:classid/' element={<SignupClassView />} />
              <Route exact path='/signup-block/:blockid/' element={<SignupBlockView />} />
              <Route exact path='/class-info/:classid/' element={<InfoOnlyClassView />} />
              <Route exact path='/block-info/:blockid/' element={<InfoOnlyBlockView />} />
              <Route
                exact
                path='/participant-awards/:participantid/'
                element={<ParticipantAwards />}
              />
              <Route
                exact
                path='/participant-progress/:participantid/'
                element={<ParticipantProgress />}
              />
              <Route
                exact
                path='/participant-progress-view/:participantid/:reportcardid/'
                element={<ParticipantProgressView />}
              />

              <Route exact path='/success/' element={<Success />} />
              <Route exact path='/failure/' element={<Failure />} />

              {/* Tutor Routes */}
              <Route exact path='/tutor' element={<TutorLogin updateLoginKey={updateLoginKey} />} />
              <Route exact path='/tutor/reset' element={<ForgotPasswordTutor />} />
              <Route exact path='/tutor/reset/:token/:id' element={<ReplacePasswordTutor />} />
              <Route exact path='/tutor/dashboard/' element={<TutorOverview />} />
              <Route exact path='/tutor/classes/:classid' element={<TutorClassInfoParent />} />
              <Route exact path='/tutor/blocks/:blockid' element={<TutorBlockInfoParent />} />
              <Route path='/tutor/registers/:registerid' element={<TutorRegisterManage />} />
              <Route path='/tutor/block-registers/:blockid' element={<TutorBlockRegister />} />
              <Route
                path='/tutor/award-participant/:participantid'
                element={<TutorAwardParticipant />}
              />
              <Route
                exact
                path='/tutor/reportcards/:type/:classid/:participantid'
                element={<TutorReportCardGenerate />}
              />
              <Route
                exact
                path='/tutor/reportcardsview/:reportcardid'
                element={<TutorReportCardView />}
              />

              {/* Admin Routes */}
              <Route exact path='/admin' element={<AdminLogin updateLoginKey={updateLoginKey} />} />
              <Route exact path='/admin/reset' element={<ForgotPasswordAdmin />} />
              <Route exact path='/admin/reset/:token/:id' element={<ReplacePasswordAdmin />} />
              <Route exact path='/admin/class-types/' element={<ClassTypes />} />
              <Route exact path='/admin/tutor-list/' element={<TutorList />} />
              <Route exact path='/admin/venue-list/' element={<VenueList />} />
              <Route path='/admin/venue-list/:_id/' element={<Venue />} />
              <Route path='/admin/classes/:classid/' element={<RegularClassManage />} />
              <Route path='/admin/blocks/:blockid/' element={<BlockClassManage/>} />
              <Route exact path='/admin/customer-list/' element={<CustomerList />} />
              <Route path='/admin/customer-list/:_id' element={<CustomerView />} />
              <Route exact path='/admin/awards/' element={<AwardsTypesList />} />
              <Route
                path='/admin/award-participant/:participantid'
                element={<AwardParticipant />}
              />
              <Route path='/admin/registers/:registerid' element={<RegisterManage />} />
              <Route path='/admin/block-registers/:blockid' element={<BlockRegister/>} />
              <Route
                exact
                path='/admin/reportcards/:type/:classid/:participantid'
                element={<ReportCardGenerate />}
              />
              <Route
                exact
                path='/admin/reportcardsview/:reportcardid'
                element={<ReportCardView />}
              />
              <Route exact path='/admin/overview/' element={<OverviewPage />} />
              <Route exact path='/admin/configure/' element={<Configure />} />

              {/* Not Found Route */}
              <Route element={<NotFound />} />
            </Routes>
          </Router>
        </AnalyticsProvider>
        <Footer />
      </div>
    );
  } else {
    return <LoadingSpinner />;
  }
};

export default withRouter(App);
